/* One native newsletter form and one invitation; never capture consent for the visitor. */
(() => {
  'use strict';
  const campaignOpen = (node) => {
    const start = Date.parse(node.dataset.campaignStart);
    const end = Date.parse(node.dataset.campaignEnd);
    return Number.isFinite(start) && Number.isFinite(end) && end > start && Date.now() >= start && Date.now() < end;
  };
  let expiryTimer;
  const expireCampaigns = () => {
    window.clearTimeout(expiryTimer);
    let next = Infinity;
    document.querySelectorAll('[data-campaign-end]').forEach((node) => {
      if (!campaignOpen(node)) {
        if (node instanceof HTMLDialogElement && node.open) node.close();
        node.hidden = true;
      } else {
        next = Math.min(next, Date.parse(node.dataset.campaignEnd) - Date.now());
      }
    });
    if (Number.isFinite(next)) expiryTimer = window.setTimeout(expireCampaigns, Math.min(Math.max(next, 1), 86400000));
  };
  expireCampaigns();
  window.addEventListener('pageshow', expireCampaigns);
  document.addEventListener('visibilitychange', expireCampaigns);
  document.addEventListener('shopify:section:load', expireCampaigns);
  const dialog = document.querySelector('[data-welcome-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'melo-welcome-dismissed';
  const sessionKey = 'melo-welcome-seen';
  const started = Date.now();
  let shown = false;
  let engaged = false;
  let opener;
  const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
  const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch { /* Storage is optional. */ } };
  const remove = (storage, name) => { try { window[storage].removeItem(name); } catch { /* Storage is optional. */ } };
  const storageAllowed = () => Boolean(window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.());
  const recentlyDismissed = () => {
    if (!storageAllowed()) return false;
    const stored = read('localStorage', key);
    const dismissed = Number(stored);
    const age = Date.now() - dismissed;
    const recent = Number.isFinite(dismissed) && dismissed > 0 && age >= 0 && age < 7 * 86400000;
    if (stored !== null && !recent) remove('localStorage', key);
    return Boolean(read('sessionStorage', sessionKey)) || recent;
  };
  const syncStoredPreferences = () => {
    if (!window.Shopify?.customerPrivacy?.preferencesProcessingAllowed) return;
    if (storageAllowed()) { recentlyDismissed(); return; }
    remove('localStorage', key);
    remove('sessionStorage', sessionKey);
  };
  const privacyBusy = () => [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')].some((node) => node.getClientRects().length > 0);
  const privacyPending = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.currentVisitorConsent || !privacy?.shouldShowBanner) return true;
    const consent = privacy.currentVisitorConsent();
    return privacy.shouldShowBanner() && !['marketing', 'analytics', 'preferences'].some((key) => consent[key] === 'yes' || consent[key] === 'no');
  };
  function open(manual = false) {
    if (!campaignOpen(dialog) || dialog.hidden) return false;
    if (dialog.open || document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || privacyBusy()) return false;
    if (!manual && (privacyPending() || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]'))) return false;
    if (!manual && (shown || recentlyDismissed() || !engaged || Date.now() - started < 30000)) return false;
    opener = document.activeElement;
    dialog.showModal();
    shown = true;
    if (storageAllowed()) write('sessionStorage', sessionKey, '1');
    dialog.querySelector('[data-welcome-close]')?.focus({ preventScroll: true });
    return true;
  }
  function close() {
    dialog.close();
    // Persist the explicit dismissal only where preference storage is allowed.
    if (storageAllowed()) write('localStorage', key, String(Date.now()));
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-welcome-open]') && open(true)) event.preventDefault();
    if (event.target.closest('[data-welcome-close]')) close();
  });
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  window.addEventListener('scroll', () => {
    const distance = document.documentElement.scrollHeight - innerHeight;
    if (distance > 0 && scrollY / distance >= 0.4) engaged = true;
    if (engaged && Date.now() - started >= 45000) open();
  }, { passive: true });
  document.addEventListener('mouseout', (event) => {
    if (matchMedia('(hover: hover) and (pointer: fine)').matches && event.relatedTarget === null && event.clientY <= 0) open();
  });
  window.setTimeout(() => open(), 45000);
  document.addEventListener('visitorConsentCollected', syncStoredPreferences);
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], syncStoredPreferences);
  syncStoredPreferences();
  if (dialog.querySelector('[data-welcome-success], [data-welcome-error]')) open(true);
})();
